import { useCallback, useState } from 'react';

export default function useHoverZoom(scale: number = 1.05): {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  hoverStyle: {
    transform?: string;
    transition: string;
  };
} {
  const [hovering, setHovering] = useState(false);

  const onMouseEnter = useCallback(() => setHovering(true), []);
  const onMouseLeave = useCallback(() => setHovering(false), []);

  const hoverStyle = {
    transition: 'transform 0.2s ease-in-out',
    transform: hovering ? `scale(${scale})` : undefined,
  };

  return {
    onMouseEnter,
    onMouseLeave,
    hoverStyle,
  };
}
